export default (context) => { 
    return {
      config: {
        pageSize: 40,
        list: false,
      },
  
      actions: {
        create: true,
        edit: true,
        delete: true,
        print: false,
        export: true,
        search: true
      },
  
      filter: {
        fields: [
          {
            name: "type",
            value: "SYM",
            type: "select",
            label: "main.type",
            opts: {
              style: 'float-label',
              items: [
                { value: "SYM", label: "Síntoma" },
                { value: "OUT", label: "Partió a" }
              ],
            },
            onChange: (ctx) => {
              if (context.state.formFilter.type && (context.state.formFilter.type.value === ctx.state.type)) return
              process.nextTick(() => { context.resetDataTable() })
            }
          }
        ]
      },
  
      form: {
        fields: [
          {
            col: 6,
            name: "type",
            value: "",
            type: "select",
            label: "main.type",
            rules: 'required',
            opts: {
              style: 'float-label',
              items: [
                { value: "SYM", label: "Síntoma" },
                { value: "OUT", label: "Partio a" }
              ],
            }
          },
          {
            col: 6,
            name: "name",
            value: null,
            type: "text",
            label: "main.name",
            rules: 'required',
            opts: {
              style: 'float-label'
            }
          },
          {
            col: 6,
            name: "desc",
            value: null,
            type: "text",
            label: "main.desc",
            rules: 'required',
            opts: {
              style: 'float-label'
            }
          }
        ]
      },
  
      columns: [
        {
          Header: "main.ID",
          accessor: "ID"
        },
        {
          Header: "main.desc",
          accessor: "name"
        },
        {
          Header: "main.name",
          accessor: "desc",
        }
      ]
    }
  }